// @flow
/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import cx from 'classnames';
import * as styles from './InputBox.module.scss';

type Props = {
  label: string,
  errors: Object,
  name: string,
  onChange: Function,
  // optional params
  placeholder?: string,
  size?: string,
  type?: string,
  value: ?string | ?number,
  onBlur?: Function,
  onCompositionStart?: Function,
  onCompositionUpdate?: Function,
  onCompositionEnd?: Function,
  isRequired?: boolean, // this is just for (任意)
  customError?: string,
  unit?: string,
  maxLength?: number,
};

const InputBox = ({
  label,
  size,
  type,
  errors,
  name,
  placeholder,
  value,
  onChange,
  onBlur,
  onCompositionStart,
  onCompositionUpdate,
  onCompositionEnd,
  isRequired,
  customError,
  unit,
  maxLength,
}: Props) => {
  const isIncome = name === 'annual_income' || name === 'income';

  const _onChange = event => {
    const newValue = event.currentTarget.value;

    if (maxLength && newValue && newValue.toString().length > maxLength) {
      return;
    }

    onChange(event);
  };

  const preventDefaultForKeyUpDown = event => {
    // override the default browser behavior to disable the increment/decrement functions via key up/down
    if (type === 'number' && ['ArrowUp', 'ArrowDown'].includes(event.key)) {
      event.preventDefault();
    }
  };

  const handleWheelEvent = event => {
    event.preventDefault();
  };

  const addWheelListener = event => {
    if (type === 'number') {
      event.target.addEventListener('wheel', handleWheelEvent, { passive: false });
    }
  };

  const removeWheelListener = event => {
    if (type === 'number') {
      event.target.removeEventListener('wheel', handleWheelEvent);
    }
  };

  return (
    <div className={cx(size, errors[name] ? 'error' : '', customError ? 'error' : '')}>
      {label && <label htmlFor={`ip_${name}`}>{`${label} ${!isRequired ? '(任意)' : ''}`}</label>}
      <input
        // eslint-disable-next-line no-nested-ternary
        className={cx(name, unit ? styles.withUnit : maxLength ? styles.withUnit : '')}
        id={`ip_${name}`}
        type={type}
        pattern={type === 'number' || type === 'tel' ? '\\d*' : undefined}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={_onChange}
        onBlur={e => {
          removeWheelListener(e);
          // eslint-disable-next-line no-unused-expressions
          onBlur && onBlur(e);
        }}
        onFocus={addWheelListener}
        onCompositionStart={onCompositionStart}
        onCompositionUpdate={onCompositionUpdate}
        onCompositionEnd={onCompositionEnd}
        onKeyDown={preventDefaultForKeyUpDown}
      />
      {unit && <span className={styles.unit}>{unit}</span>}
      {!unit && !!maxLength && maxLength > 0 && (
        <span className={styles.unit}>{`${value ? value.toString().length : 0}/${maxLength}`}</span>
      )}
      {isIncome && (
        <div>
          <em>{value || <span className={styles.placeholder}>0</span>}</em>
          <span className={styles.sub}>万円</span>
        </div>
      )}
      {errors[name] && <span className="input-error">{errors[name]}</span>}
      {customError && <span className="input-error">{customError}</span>}
    </div>
  );
};

InputBox.defaultProps = {
  placeholder: '',
  size: 'full',
  isRequired: true,
  onValidate: () => { },
  onBlur: () => { },
  onCompositionStart: () => { },
  onCompositionUpdate: () => { },
  onCompositionEnd: () => { },
  type: 'text',
  customError: '',
  unit: '',
  maxLength: 0,
};

export default InputBox;
